module.exports = __webpack_public_path__ + "img/ljzt_ico.e3f8b7ad.png";